// This middleware reports failures and exceptions to Sentry Raven

import failureActionTypes from './failureActionTypes'
import reportError from './reportError'

export default () => (next) => (action) => {
  if (process.env.NODE_ENV !== 'production') {
    return next(action)
  }

  if (failureActionTypes(action.type)) {
    const err = new Error(action.type)
    reportError(err, action)
  }

  try {
    return next(action)
  } catch (err) {
    return reportError(err, action)
  }
}
